import React from "react";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

function EmptyHeaderCell({ mode, option, action }) {
  const access = useChapterActionIdMatch(action);

  return <>{mode === "edit" && option.editTable && access && <th>Действие</th>}</>;
}

export default EmptyHeaderCell;
